import React from 'react'
import { Wizard } from '@vwfs-bronson/bronson-react'
import formConfiguration from './index.json'
import { useTranslation } from 'react-i18next'

const JourneyWizard = ({ step }) => {
  const { t } = useTranslation()

  return (
    <Wizard
      collapsedText={formConfiguration.steps[step - 1].name}
      collapseBreakpoint="s"
      ariaLabel={t('page:wizardAriaLabel')}
      noInteraction
      stepLabels={{
        doneLabel: 'Rempli',
        errorLabel: 'Erreur',
        notDoneLabel: 'Pas terminé',
        noInteractionLabel: 'Aucune interaction',
      }}
    >
      {formConfiguration.steps.map((item, index) => {
        return (
          <Wizard.Item
            key={item.name}
            done={index + 1 < step}
            active={index + 1 === step}
          >
            {item.name}
          </Wizard.Item>
        )
      })}
    </Wizard>
  )
}

export default JourneyWizard
